export class AdModel {
  wasViewed: boolean = false;

  constructor(public src: string, public skipTime: number) {}

  canBeSkipped() {
    return this.skipTime != -1;
  }
}
